import { reactive } from "@vue/composition-api";
import _axios from "@/axios";

export function useCbTransaction() {
  let data = reactive({
    transactions: [],
    options: {},
    firstLoad: true,
    isLoading: false,
  });

  function listCBTransactions(clientPortal = null, filterParams = null) {
    data.isLoading = true;

    const params = new URLSearchParams();

    params.set("page", data.options.page ?? 1);
    params.set("itemsPerPage", data.options.itemsPerPage ?? 100);

    if (data.options.sortBy && data.options.sortBy.length > 0) {
      if (data.options.sortDesc[0]) {
        params.set("order[desc]", data.options.sortBy[0]);
      } else {
        params.set("order[asc]", data.options.sortBy[0]);
      }
    }

    if (clientPortal != null && clientPortal != undefined) {
      params.set("clientId", clientPortal.id);
    }

    if (filterParams !== null) {
      if (filterParams.email !== "" && filterParams.email !== undefined) {
        params.set("mail", filterParams.email);
      }
      if (filterParams.numCb !== "" && filterParams.numCb !== undefined) {
        params.set("numCb[partial]", filterParams.numCb);
      }
      if (filterParams.clientId !== "" && filterParams.clientId !== undefined) {
        params.set("clientId", filterParams.clientId);
      }
      if (
        filterParams.transactionId !== "" &&
        filterParams.transactionId !== undefined
      ) {
        params.set("transactionId", filterParams.transactionId);
      }
      if (filterParams.bill !== "" && filterParams.bill !== undefined) {
        params.set("bill", filterParams.bill);
      }
      if (
        filterParams.dateRange !== undefined &&
        filterParams.dateRange != null &&
        filterParams.dateRange.length == 2
      ) {
        params.set("realDate[][after]", filterParams.dateRange[0]);
        params.set("realDate[][before]", filterParams.dateRange[1]);
      }
    }

    return _axios
      .get("/list-transaction?" + params.toString())
      .then((response) => {
        data.transactions = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        data.isLoading = false;
        data.firstLoad = false;
      });
  }

  return {
    listCBTransactions,
    data,
  };
}
